<template>
    <div>
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-radio-group
                    label="Jornada"
                    v-model="model.escala.jornadaEmHoras"
                    :options="form.jornadas"
                    buttons
                    button-color="outline-primary"
                    :validations="validations.jornada"
                    :disabled="disabled"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    label="Número de atendimentos"
                    number
                    v-model="model.escala.quantidadeAtendimentos"
                    :validations="validations.quantidadeAtendimentos"
                    :disabled="disabled"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-checkbox-group
                    label="Dias da semana"
                    :validations="validations.diasSemana"
                    v-model="model.escala.diasSemana"
                    :options="form.diasSemana"
                    buttons
                    button-color="outline-primary"
                    :disabled="disabled"
                />
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Mixins.
import { calculations } from '@/mixins'

export default {
    mixins: [ calculations ],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        disabled: { type: Boolean, default: false },
    },
    computed: {
        validations() {

            return {
                jornada: { required: true },
                quantidadeAtendimentos: { required: true, max: 8 },
                diasSemana: { required: true },
            }
        },
    },
    watch: {
        'model.escala.jornadaEmHoras': function () {

            this.model.escala.diasSemana = []

            this.$nextTick(() => this.checkDays())
        },
        'model.escala.diasSemana': function () {

            this.checkDays()
        },
    },
    methods: {
        checkDays() {

            const notAllowedDays = []

            if (this.model.escala.jornadaEmHoras === 12) {

                this.model.escala.diasSemana.map(selectedDay => {

                    notAllowedDays.push(
                        this.weekCalcs().sub(selectedDay, 1),
                        this.weekCalcs().sum(selectedDay, 1)
                    )
                })
            }
            else if (this.model.escala.jornadaEmHoras === 24) {

                this.model.escala.diasSemana.map(selectedDay => {

                    notAllowedDays.push(
                        this.weekCalcs().sub(selectedDay, 1),
                        this.weekCalcs().sub(selectedDay, 2),
                        this.weekCalcs().sum(selectedDay, 1),
                        this.weekCalcs().sum(selectedDay, 2)
                    )
                })
            }

            this.form.diasSemana.map(day => day.disabled = !!notAllowedDays.find(d => d === day.value))
        },
    }
}
</script>